import { useLazyQuery } from '@apollo/client'
import { ReactElement, ReactNode, useState } from 'react'

import { SelectTags } from 'components/v2/SelectTags'
import { GET_DRIVERS_SUGGESTIONS } from 'features/Drivers/queries-legacy'
import { GTDriverSuggestionsResponse, GTTDriverAutocomplete } from 'gql/types.generated'
import { useDebouncedQuery } from 'components/v2/Autocomplete'

export interface IDriverAutocomplete {
  id: string
  name: string
}

interface IMultiDriverAutocompleteProps {
  partnerId?: string
  onChange: (drivers: IDriverAutocomplete[]) => void
  label?: ReactNode
  placeholder?: string
  values: IDriverAutocomplete[]
}

export const MultiDriverAutocomplete = ({
  partnerId,
  onChange,
  label,
  placeholder,
  values
}: IMultiDriverAutocompleteProps): ReactElement => {
  const [pattern, setPattern] = useState('')
  const [getDrivers, { data, loading, error }] = useLazyQuery<{ driverSuggestions: GTDriverSuggestionsResponse }>(
    GET_DRIVERS_SUGGESTIONS
  )
  const { isDebouncing, shouldShowItems } = useDebouncedQuery({
    query: getDrivers,
    pattern,
    extraInputs: {
      partnerID: partnerId || null
    }
  })

  const shownItems =
    data?.driverSuggestions?.items.filter((driver) => !values.map(({ name }) => name).includes(driver.name || '')) || []
  const sortedItems = [...shownItems].sort((a, b) => (a.name || '').localeCompare(b.name || ''))

  const handleChange = (drivers: GTTDriverAutocomplete[], pattern = ''): void => {
    onChange(drivers.map((driver) => ({ id: driver.id, name: driver.name || '' })))
    setPattern(pattern)
  }

  return (
    <SelectTags
      placeholder={placeholder}
      values={values}
      label={label}
      items={sortedItems}
      getTagLabel={(driver: IDriverAutocomplete): string => driver.name || ''}
      onChange={handleChange}
      loading={loading || isDebouncing}
      error={error}
      shouldShowItems={shouldShowItems}
    />
  )
}
